import { Icon } from './_Icon';
export const CloseIcon = (props) => <Icon {...props} d="M18 6L6 18 M6 6l12 12" />;
